import React, { useEffect } from "react";
import PrimaryButton from "../../shared/components/CustomButtons";
// import AfterImg from "../../assets/images/afterimg.webp";
// import BeforeImg from "../../assets/images/beforeimg.webp";
import SplitterImgBox from "../../shared/components/SplitterImgBox";
import { DataView } from "primereact/dataview";
import ProductCard from "../../shared/components/ProductCard";
// import ProductImg from "../../assets/images/product/chair.svg";
import { Carousel } from "primereact/carousel";
import ServiceCard from "../../shared/components/ServiceCard";
import Footer from "../../layout/Footer";
import CustomImage from "../../shared/components/CustomImage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOurWorkDetails } from "../../store/slices/contentSlice";
import { fetchSubServices } from "../../store/slices/servicesSlice";

export default function OurWorkDetail() {
  const { id, serviceId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ourWorkDetails } = useSelector((state) => state.content);
  const { subServices } = useSelector((state) => state.service);

  useEffect(() => {
    dispatch(fetchOurWorkDetails(id));
    dispatch(fetchSubServices(serviceId));
  }, [id, dispatch]);

  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  const SericeTemplate = (item) => {
    return (
      <ServiceCard
        extraClass="m-2"
        AfterImg={item?.primaryAfterImage}
        BeforeImg={item?.primaryBeforeImage}
        singleImage={item?.primarySingleImage}
        hasBeforeAfterImage={item?.hasBeforeAfterImages}
        title={item?.serviceName}
        detail={item?.description}
        serviceId={item._id}
        style={{ width: "320px", height: "200px", borderRadius: "12px" }}
      />
    );
  };

  const itemTemplate = (product) => {
    return (
      <ProductCard extraClass="product-card m-2" key={product._id}>

        <CustomImage
          src={product.image}
          alt={product.title}
          className="w-full h-15rem product-image m-auto block"
        />
        <p className="product-title text-black-alpha-90 font-semibold mb-0">
          {product.title}
        </p>
        <p className="text-black-alpha-90 font-normal m-0">
          {product.subTitle}
        </p>
        <PrimaryButton
          label="Buy Product"
          extraClassNames="w-auto m-auto mt-3 block border-round-6xl"
          onClick={() => window.open(product.url, "_blank")}
        />
      </ProductCard>
    );
  };

  return (
    <>
      {/* Before & After Section */}
      <div className="py-7 px-8">
        <div className="container">
          <h2 className="text-4xl text-center heading rubik font-semibold">
            {ourWorkDetails?.service?.serviceName}
          </h2>
          {ourWorkDetails?.singleImage ? (
            <>
              <CustomImage
                src={ourWorkDetails?.singleImage}
                alt=""
                className="w-full border-round-xl"
                height={600}
              />
            </>
          ) : (
            <>
              <SplitterImgBox
                BeforeImg={ourWorkDetails?.beforeImage}
                AfterImg={ourWorkDetails?.afterImage}
                label
                style={{ height: "500px" }}
              />
            </>
          )}
          <PrimaryButton
            label="Place Order"
            extraClassNames="w-auto mt-3 mx-auto block"
            onClick={() => navigate(`/orders/place-order/${serviceId}`)}
          />
        </div>
      </div>

      {/* Products Section */}
      <div className="py-7 px-4">
        <div className="container">
          <h2 className="text-4xl text-center heading rubik font-semibold">
            Products
          </h2>
          <p className="content text-center">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </p>
          <div className="grid mt-5">
            <DataView
              value={ourWorkDetails?.products}
              itemTemplate={itemTemplate}
              layout="grid"
            />
          </div>
        </div>
      </div>

      {/* similar service */}
      {subServices.length ? (
        <div className="py-8 bg-gray">
          <div className="container mb-6">
            <h2 className="heading text-center text-4xl mb-3 rubik">
              Explore Similar Services
            </h2>
            {/* <p className="text-gray-color text-center text-lg">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s
            </p> */}

            <Carousel
              className="w-full testimonial-container"
              value={subServices}
              numVisible={3}
              numScroll={1}
              responsiveOptions={responsiveOptions}
              itemTemplate={SericeTemplate}
              showIndicators={false}
            />
          </div>
        </div>
      ) : null}
      <Footer />
    </>
  );
}
